import { useEffect, useRef, useState } from "react";

/**
 * Wraps children with an IntersectionObserver-triggered fade+slide-up.
 * Use `as` to change element, `delay` (ms) to stagger, `scale` for slight zoom.
 */
export default function Reveal({ as: Tag = "div", delay = 0, scale = false, className = "", children, ...rest }) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setVisible(true), delay);
          io.unobserve(el);
        }
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [delay]);

  const base = scale ? "reveal-scale" : "reveal";
  return (
    <Tag ref={ref} className={`${base} ${visible ? "is-visible" : ""} ${className}`} {...rest}>
      {children}
    </Tag>
  );
}
